import { AxiosRequestConfig } from "axios";
const getNumber = (def: number, envName?: string) => {
  if (envName) {
    const t = Number(process.env[envName]);
    if (t && isFinite(t)) return t;
  }
  return def;
};
const getBoolean = (def: boolean, envName?: string) => {
  if (envName && process.env[envName]) return Boolean(process.env[envName]);
  return def;
};

const axiosConfig: AxiosRequestConfig = {
  timeout: getNumber(30000, "AXIOS_TIMEOUT"),
}; // 请求超时时间

const interceptorsConfigs = {
  allowDuplicateRequest: getBoolean(true, "AXIOS_ALLOW_DUPLICATE_REQ"),
};
export { axiosConfig, interceptorsConfigs };
